<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-checkbox-docs-preview></ui-checkbox-docs-preview></p>
<h1 id="description">Description</h1>
<p>Default button.</p>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-checkbox</span> <span class="hljs-attr">label</span>=<span class="hljs-string">"Single checkbox"</span> [(<span class="hljs-attr">selected</span>)]=<span class="hljs-string">"selectedBool"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">ui-checkbox</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ui-selectable-list</span>
    #<span class="hljs-attr">multiList</span>
    [(<span class="hljs-attr">selected</span>)]=<span class="hljs-string">"multiSelectedOptions"</span>
    [<span class="hljs-attr">multiSelect</span>]=<span class="hljs-string">"true"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">ui-checkbox</span>
        *<span class="hljs-attr">ngFor</span>=<span class="hljs-string">"let option of checkboxOptions"</span>
        [<span class="hljs-attr">label</span>]=<span class="hljs-string">"option.label"</span>
        [<span class="hljs-attr">value</span>]=<span class="hljs-string">"option"</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">ui-checkbox</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-selectable-list</span>&gt;</span></code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">label</td>
<td align="left">Label of the checkbox</td>
</tr>
</tbody></table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
